export default __webpack_public_path__ + "static/media/typed.cf3aba4c.png";